import { supabase } from './supabaseClient';
import type { Coordinates } from './locationSearch';

export async function fetchVenueCoordinates(venueIds: string[]) {
  const uniqueIds = Array.from(new Set(venueIds.map((id) => String(id || '').trim()).filter(Boolean)));
  if (uniqueIds.length === 0) return new Map<string, Coordinates>();

  const { data, error } = await supabase
    .from('Venues')
    .select('id, latitude, longitude')
    .in('id', uniqueIds);

  if (error) {
    console.error('[venue coordinates] lookup failed:', error);
    return new Map<string, Coordinates>();
  }

  const coords = new Map<string, Coordinates>();

  for (const row of data || []) {
    const lat = Number((row as any)?.latitude);
    const lng = Number((row as any)?.longitude);
    const id = String((row as any)?.id || '').trim();

    if (id && Number.isFinite(lat) && Number.isFinite(lng)) {
      coords.set(id, { lat, lng });
    }
  }

  return coords;
}
